<template>
    <div class="header">
        <div class="nav-box">
            <div class="logo-box">
                <app-link class="icon" to="/"></app-link>
                <span class="slogan" v-html="navData.slogan"></span>
            </div>

            <div class="menu">

                <ul class="list-box">
                    <li>
                        <app-link to="/">首页</app-link>
                    </li>
                    <li v-if="navData.productNav.length>0">
                        <el-dropdown placement="bottom" ref="productDropdown">
                            <span class="el-dropdown-link product-nav">
                                产品<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <div class="product-panel">
                                    <ul class="list-box">
                                        <li class="item-box" v-for="item in navData.productNav" :key="item.path">
                                            <div class="chunk">
                                                <em class="marked"></em>
                                                <app-link @click.native="handleLink" :to="item.path">{{item.name}}</app-link>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li>
                        <app-link to="/corp">公司介绍</app-link>
                    </li>
                </ul>

                <div class="manage-box" v-if="hasToken">

                    <el-dropdown>
                        <el-button class="btn-box" type="primary" icon="el-icon-menu">管理中心</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="goMaster">
                                <i class="icon el-icon-user"></i>用户中心
                            </el-dropdown-item>
                            <el-dropdown-item divided @click.native="logout">
                                <i class="icon el-icon-switch-button"></i>退出登录
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="btns-box" v-else>
                    <div class="item-box">
                        <app-link class="login" to="/login">登录</app-link>
                    </div>
                    <div class="item-box">
                        <app-link class="reg" to="/reg">注册</app-link>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import AppLink from "@/components/common/link";
import auth from "@/core/auth";
import { Dropdown, DropdownMenu, Button } from "element-ui";
import appConfig from "@/config/app"; 

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(Button);

const page = {
    data() {
        return {
            hasToken: "",
        };
    },
    props: {
        navData: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        AppLink,
    },
    methods: {
        goMaster() {
            const href = appConfig.domain.master;
            document.location.href = href;
        },
        async logout() {
            const href = appConfig.domain.app;
            await this.$store.dispatch("user/logout").then(() => {
                document.location.href = href;
            });
        },
        handleLink(){
            this.$refs.productDropdown.hide();
        }
    },
    created: function () {
        const hasToken = auth.getToken();
        this.hasToken = hasToken;
    },
};
export default page;
</script>

<style>
.product-nav {
    font-size: 16px;
    color: #333;
    text-decoration: none;
    -webkit-transition: color 0.3s;
    transition: color 0.3s;
    cursor: pointer;
}
.product-nav:hover {
    color: #136ad5;
}
</style>
<style lang="scss" scoped>
.header {
    height: 70px;
    line-height: 70px;
    background-color: #fff;
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.1);
}

.header .nav-box {
    margin: 0 auto;
    min-width: 1200px;
    max-width: 1920px;
    height: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header .logo-box {
    display: flex;
    margin-left: 50px;
}

.header .logo-box .icon {
    display: block;
    width: 280px;
    height: 70px;
    background: url("~@/assets/images/public/logo.png") center no-repeat;
    background-size: contain;
}

.header .logo .icon img {
    width: 100%;
    height: 100%;
}

.header .logo-box .slogan {
    font-size: 16px;
    margin-left: 20px;
    color: #aaa;
}

.header .menu {
    position: relative;
    float: right;
    width: auto;
    height: 70px;
}

.header .menu .list-box {
    display: inline-block;
    vertical-align: top;
}

.header .menu .list-box .current {
    color: #136ad5;
}

.header .menu ul li {
    float: left;
    position: relative;
    display: block;
    margin-right: 50px;
}

.header .menu ul li a {
    font-size: 16px;
    color: #333;
    text-decoration: none;
    transition: color 0.3s;
    cursor: pointer;
}

.header .menu ul li a:hover {
    color: #136ad5;
}

.header .manage-box {
    display: inline-block;
    position: relative;
    vertical-align: top;
    margin-left: 50px;
}

.header .manage-box .btn-box {
    height: 70px;
    border-radius: 0;
}

.header .btns-box {
    display: inline-block;
    position: relative;
    vertical-align: top;
    margin-right: 50px;
}

.header .btns-box .login {
    width: 80px;
    margin: 17px 0;
    display: inline-block;
    vertical-align: middle;
    height: 36px;
    line-height: 34px;
    border: 1px solid #0076fe;
    text-align: center;
    background-color: #0076fe;
    font-size: 14px;
    border-radius: 28px;
    color: #fff;
    box-sizing: border-box;
}

.header .btns-box .login:hover {
    background-color: #2288fe;
    border-color: #5776ff;
    color: #fff;
    transition: background-color 0.3s, border-color 0.3s;
}

.header .btns-box .reg {
    width: 80px;
    margin: 17px 0;
    display: inline-block;
    vertical-align: middle;
    height: 36px;
    line-height: 34px;
    border: 1px solid #dcdcdc;
    border-radius: 28px;
    text-align: center;
    font-size: 14px;
    color: #333;
    background: #fff;
    box-sizing: border-box;
    transition: color 0.3s, border-color 0.3s;
}

.header .btns-box .reg:hover {
    border-color: #0076fe;
    color: #0076fe;
}

.header .btns-box .item-box {
    display: inline-block;
    margin-right: 15px;
}

.product-panel {
    width: 960px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.product-panel a:hover {
    color: #0076fe;
}

.product-panel .list-box {
    display: block;
    height: 100%;
    padding: 13px 30px 0;
    box-sizing: border-box;
}

.product-panel .list-box .item-box {
    float: left;
    width: 300px;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
}

.product-panel .list-box .chunk {
    display: flex;
    align-items: center;
}

.product-panel .list-box .marked {
    display: inline-block;
    width: 10px;
    height: 12px;
    background: #0076fe;
    margin-right: 10px;
}

@media screen and (max-width: 767px) {
    .header .nav-box {
        min-width: auto;
    }
    .header .logo-box {
        margin-left: 10px;
    }
    .header .logo-box .icon {
        width: 100px;
        height: 70px;
    }
    .header .logo-box .slogan {
        font-size: 0.8em;
    }

    .header .menu {
        position: absolute;
        float: unset;
        width: auto;
        height: 70px;
        z-index: 99999999;
        top: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 15px;
    }

    .header .menu ul li {
        margin-right: 1.5em;
    }

    .header .menu ul li a {
        font-size: 14px;
    }

    .header .btns-box {
        margin-right: 0px;
    }

    .header .btns-box .login {
        width: 3em;
        border-radius: 0px;
    }

    .header .btns-box .reg {
        width: 3em;
        border-radius: 0px;
    }

    .header .btns-box .item-box {
        margin-right: 0px;
    }

    .product-panel {
        width: 270px;
        height: 300px;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .product-panel .list-box .item-box {
        width: auto;
        float: unset;
    }
}

@media screen and (max-width: 768px) and (min-width: 767px) {
    .header .nav-box {
        min-width: auto;
    }
    .header .logo-box {
        margin-left: 10px;
    }
    .header .logo-box .icon {
        width: 100px;
        height: 70px;
    }
    .header .logo-box .slogan {
        font-size: 0.8em;
    }

    .header .menu {
        position: relative;
        float: unset;
        width: auto;
        height: 70px;
        z-index: 99999999;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 15px;
    }

    .header .menu ul li {
        margin-right: 20px;
    }

    .header .menu ul li a {
        font-size: 14px;
    }

    .header .btns-box {
        margin-right: 20px;
    }

    .header .btns-box .login {
        width: 70px;
    }

    .header .btns-box .item-box {
        margin-right: 0px;
    }
}

@media screen and (min-width: 1024px) and (max-width: 1024px) {
    .header .nav-box {
        min-width: auto;
    }
    .header .logo-box {
        margin-left: 10px;
    }
    .header .logo-box .icon {
        width: 150px;
        height: 70px;
    }
    .header .logo-box .slogan {
        font-size: 14px;
    }

    .header .menu {
        position: relative;
        float: unset;
        width: auto;
        height: 70px;
        z-index: 99999999;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 15px;
    }

    .header .menu ul li {
        margin-right: 30px;
    }

    .header .menu ul li a {
        font-size: 14px;
    }

    .header .btns-box {
        margin-right: 20px;
    }

    .header .btns-box .login {
        width: 70px;
    }

    .header .btns-box .item-box {
        margin-right: 10px;
    }
}

@media screen and (max-width: 1440px) and (min-width: 1024px) {
    .header .nav-box {
        justify-content: start;
    }

    .header .menu {
        margin-left: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/layout/app/components/navbar/index.vue